import { render } from "./Footer.vue?vue&type=template&id=1f64bf26"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=1f64bf26&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__